"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventsProviderSaga = eventsProviderSaga;
const effects_1 = require("redux-saga/effects");
const slice_1 = require("../slice");
const fetchEventsSaga_1 = require("./fetchEventsSaga");
const fetchTournamentsSaga_1 = require("./fetchTournamentsSaga");
const sseSaga_1 = require("./sseSaga");
const listsSaga_1 = require("./listsSaga");
function* eventsProviderSaga() {
    yield (0, effects_1.all)([
        /** Fetching Events */
        (0, effects_1.takeEvery)(slice_1.eventsProviderActions.fetchEvents.type, fetchEventsSaga_1.fetchEventsSaga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchEventsLive.type, fetchEventsSaga_1.fetchEventsSaga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchEventsLine.type, fetchEventsSaga_1.fetchEventsSaga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchEvent.type, fetchEventsSaga_1.fetchEventSaga),
        (0, effects_1.takeEvery)(slice_1.eventsProviderActions.fetchEventEvery.type, fetchEventsSaga_1.fetchEventSaga),
        (0, effects_1.takeEvery)(slice_1.eventsProviderActions.fetchEventProbabilities.type, fetchEventsSaga_1.fetchEventSaga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchEventStatistics.type, fetchEventsSaga_1.fetchEventStatisticsSaga),
        /** Fetching Favourites */
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchFavouriteEvents.type, fetchEventsSaga_1.fetchFavouritesEventsByIdsSaga),
        /** Fetching Scheduled Live Events */
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchScheduledLiveEvents.type, fetchEventsSaga_1.fetchScheduledLiveEventsSaga),
        /** Fetching Linked Events */
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchLinkedEvents.type, fetchEventsSaga_1.fetchLinkedEventsSaga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchLinkedEventsAndComputeProbabilities.type, fetchEventsSaga_1.fetchLinkedEventsAndComputeProbabilitiesSaga),
        /** Fetching Tournaments */
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchTournaments.type, fetchTournamentsSaga_1.fetchTournamentsSaga),
        /** SSE - Subscribe / Unsubscribe */
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.subscribeTopEventsSSE, (0, sseSaga_1.subscribeUpdatesByTopEventsSSESaga)()),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.unsubscribeTopEventsSSE, sseSaga_1.unsubscribeUpdatesByTopEventsSSESaga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.resubscribeTopEventsSSE, sseSaga_1.resubscribeTopEventsSSESaga),
        (0, effects_1.takeEvery)(slice_1.eventsProviderActions.subscribeEventProbabilitiesSSE, (0, sseSaga_1.subscribeEventProbabilitiesSSESaga)()),
        (0, effects_1.takeEvery)(slice_1.eventsProviderActions.unsubscribeEventProbabilitiesSSE, sseSaga_1.unsubscribeEventProbabilitiesSSESaga),
        (0, effects_1.takeEvery)(slice_1.eventsProviderActions.resubscribeEventProbabilitiesSSE, sseSaga_1.resubscribeEventProbabilitiesSSESaga),
        (0, effects_1.takeEvery)(slice_1.eventsProviderActions.reloadEventProbabilitiesSSE, sseSaga_1.reloadEventProbabilitiesSSESaga),
        /** Fetching Top Live/Line Events */
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchTopLineLiveEvents, fetchEventsSaga_1.fetchTopLineLiveEventsSaga),
        /*
          EventsList sagas start
        */
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchEventList.type, listsSaga_1.fetchPage1Saga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchEventListPage1Success.type, listsSaga_1.fetchPage1SuccessSaga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchEventListNextPage.type, listsSaga_1.fetchNextPageSaga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.fetchEventListPrevPage.type, listsSaga_1.fetchPrevPageSaga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.pollEventList.type, listsSaga_1.pollPage1Saga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.pollEventListPage1Success.type, listsSaga_1.pollPage1SuccessSaga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.scrollUp.type, listsSaga_1.scrollUpSaga),
        (0, effects_1.takeLatest)(slice_1.eventsProviderActions.scrollUpPage1Success.type, listsSaga_1.scrollUpPage1SuccessSaga),
        /*
          EventsList sagas end
        */
    ]);
}
__exportStar(require("./fetchEventsSaga"), exports);
__exportStar(require("./fetchTournamentsSaga"), exports);
__exportStar(require("./fetchPlayersSaga"), exports);
__exportStar(require("./sseSaga"), exports);
__exportStar(require("./eventProcessingSaga"), exports);
__exportStar(require("./listsSaga"), exports);
//# sourceMappingURL=index.js.map